import { LOGO_URL, COMPANY, TAGLINE, PHONE_DISPLAY, PHONE_HREF, EMAIL } from "@/constants/site";

const LINKS = [
  ["About", "#about"],
  ["Services", "#services"],
  ["Sectors", "#sectors"],
  ["Process", "#process"],
  ["Founder", "#founder"],
  ["Gallery", "#gallery"],
  ["Contact", "#contact"],
];

export const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="main-footer" className="border-t border-gold/15 bg-royal-deep">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
        <div className="sm:col-span-2">
          <div className="flex items-center gap-4">
            <img
              src={LOGO_URL}
              alt="Rayasthaila logo"
              className="h-14 w-14 rounded-full bg-white object-cover p-1 ring-1 ring-gold/50"
            />
            <div>
              <p className="font-serif text-xl tracking-[0.22em] text-white">RAYASTHAILA</p>
              <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.28em] text-gold">{TAGLINE}</p>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            An international business and trade consultancy connecting businesses across borders — from market-entry
            strategy to executed partnerships.
          </p>
        </div>

        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-gold">Navigate</p>
          <ul className="mt-6 space-y-3">
            {LINKS.map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  onClick={(e) => go(e, href)}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-[11px] uppercase tracking-[0.25em] text-gold">Contact</p>
          <ul className="mt-6 space-y-3 text-sm text-slate-400">
            <li>{COMPANY}</li>
            <li>
              <a href={PHONE_HREF} className="transition-colors hover:text-gold" data-testid="footer-phone">
                {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`} className="transition-colors hover:text-gold" data-testid="footer-email">
                {EMAIL}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-slate-500 sm:flex-row lg:px-10">
          <p>© {new Date().getFullYear()} {COMPANY}. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold/60">{TAGLINE}</p>
        </div>
      </div>
    </footer>
  );
};
